import { ReviewCardIsCroppedContext } from '@contexts/review-card-is-cropped'
import { ContentType } from '@entries/content-types'
import NetreviewsReviewCard from '@entries/netreviews-review-card'
import TrustpilotReviewCard from '@entries/trustpilot-review-card'
import { useMatchMedia } from '@hooks/use-match-media'
import { Entry } from '@resolvers/entry'
import { CustomersReviewsStructuredData } from '@sd/customers-reviews-data-structured'
import { Container } from '@ui/container'
import { device } from '@utils/breakpoints'
import { chunk } from '@utils/utils'
import { graphql, useStaticQuery } from 'gatsby'
import React, { type FC, useEffect, useMemo, useState } from 'react'

const BlockSixCustomersReviews: FC = () => {
  const { reviews } = useStaticQuery<Queries.BlockSixCustomersReviewsQuery>(
    graphql`
      query BlockSixCustomersReviews {
        reviews: getBestCustomerReviews(limit: 6) {
          ...TrustpilotReviewCard
          ...NetreviewsReviewCard
        }
      }
    `
  )
  const [nbCol, setNbCol] = useState(3)
  const isLaptopLup = useMatchMedia(device.laptopL)
  const isLaptopUp = useMatchMedia(device.laptop)

  useEffect(() => {
    if (isLaptopUp) {
      setNbCol(isLaptopLup ? 3 : isLaptopUp ? 2 : 1)
    }
  }, [isLaptopUp, isLaptopLup])

  const reviewsStacks = useMemo(
    () => chunk(reviews, Math.floor(reviews.length / nbCol)),
    [reviews, nbCol]
  )

  return (
    <Container className="mb-10">
      <CustomersReviewsStructuredData reviews={reviews} />
      <div className="grid grid-cols-1 gap-4 laptop:grid-cols-2 laptop:gap-6 laptopL:grid-cols-3">
        <ReviewCardIsCroppedContext.Provider value={true}>
          {reviewsStacks.map((reviewsStack, stackIndex) => (
            <div key={stackIndex} className="grid gap-10 tablet:gap-8">
              {reviewsStack
                .filter(
                  (_, reviewIndex) => reviewIndex <= reviews.length / nbCol
                )
                .map((review) => (
                  <div key={review.id}>
                    <Entry
                      content={review}
                      mapping={{
                        [ContentType.NetreviewsReview]: NetreviewsReviewCard,
                        [ContentType.TrustpilotReview]: TrustpilotReviewCard,
                      }}
                    />
                  </div>
                ))}
            </div>
          ))}
        </ReviewCardIsCroppedContext.Provider>
      </div>
    </Container>
  )
}

export default BlockSixCustomersReviews
